import {
  getBrowserRenderableFileType,
  getFileExtensionFromFilename,
  getMimeTypeFromExtension,
  getMimeTypeFromFileName,
} from "@validereinc/utilities";
import classNames from "classnames/bind";
import React, { useEffect, useState } from "react";
import styles from "./FilePreview.module.scss";
import FilePreviewPopover from "./FilePreviewPopover";
import FileThumbnail from "./FileThumbnail";

const cx = classNames.bind(styles);

const FilePreview = ({
  file,
  isBusy,
  isLoading,
  isValid,
  onReady,
}: {
  file?: File;
  isValid?: boolean;
  isBusy?: boolean;
  isLoading?: boolean;
  isReady?: boolean;
  onReady?: (objectUrl: string) => void;
}) => {
  const [fileObjectUrl, setFileObjectUrl] = useState<string | null>(null);

  const handleDownload = () => {
    if (!file || !fileObjectUrl || isBusy) {
      return;
    }

    const link = document.createElement("a");

    link.setAttribute("href", fileObjectUrl);
    link.setAttribute("download", file.name || "");
    link.hidden = true;
    link.click();

    // destroy the object URL after 3 seconds
    setTimeout(() => URL.revokeObjectURL(fileObjectUrl), 3000);
  };

  useEffect(() => {
    if (!(file instanceof File) || !file.size) {
      setFileObjectUrl(null);
      return;
    }

    const url = URL.createObjectURL(
      new Blob(file ? [file] : [], {
        type: file.type ?? "charset=utf-8;",
      })
    );

    setFileObjectUrl(url);
    onReady?.(url);

    return () => URL.revokeObjectURL(url);
  }, [file, onReady]);

  const fileExtension = file ? getFileExtensionFromFilename(file.name) : null;
  const fileTypeRenderable = getBrowserRenderableFileType(fileExtension);
  const mimeType =
    file?.type ??
    getMimeTypeFromFileName(file?.name ?? "") ??
    getMimeTypeFromExtension(fileExtension);

  return (
    <>
      <FilePreviewPopover
        fileName={file?.name ?? null}
        fileType={fileTypeRenderable}
        fileMimeType={mimeType}
        fileExtension={fileExtension}
        fileObjectUrl={fileObjectUrl}
        onDownload={handleDownload}
        isLoading={isLoading}
        isBusy={isBusy}
        isValid={isValid}
      >
        <div className={cx("container")}>
          <FileThumbnail
            uri={fileObjectUrl ?? ""}
            file={file}
            fileType={fileTypeRenderable}
            isBusy={isBusy}
            isLoading={isLoading}
            isValid={isValid}
          />
        </div>
      </FilePreviewPopover>
    </>
  );
};

export default FilePreview;
